import React, { useCallback } from 'react';
import { AdminServiceEvents, ServicesContext } from '~/services';
import { defaultApiResponseHandler } from '~/util';

export const useUpdateUser = (events: AdminServiceEvents) => {
    const services = React.useContext(ServicesContext);

    const updateUser = useCallback(
        async (userId: number, user: Partial<UserType>, options: ApiRequestOptionsType) => {
            try {
                const result = await services.api.call(
                    {
                        method: 'put',
                        url: `/api/users/${userId}`,
                        data: user,
                    },
                    options
                );

                // Publish event
                services.events.publish(events.user_updated, result.data);

                return result.data;
            } catch (error) {
                throw defaultApiResponseHandler(error);
            }
        },
        [services.api, services.events, events.user_updated]
    );

    return updateUser;
};
